import DEFAULTS from '../constants/pricing/defaults';
import { setCookie } from '../utils/pricing';

function reducer(state, action) {
  const newState = { ...state };
  switch (action.type) {
    case 'SET_ACTIVE_TAB':
      newState.activeTab = action.payload;
      setCookie(newState);
      return newState;
    case 'SET_PACKAGE': {
      const { category, packageId } = action.payload;
      newState.packages[category] = packageId;
      setCookie(newState);
      return newState;
    }
    case 'RESET_PACKAGE':
      newState.packages[action.payload] = DEFAULTS.packages[action.payload];
      setCookie(newState);
      return newState;
    case 'SET_ADDON':
      newState.addons[action.payload.id] = action.payload.newVal;
      setCookie(newState);
      return newState;
    case 'SET_VOLUME': {
      const { category, planName, volume } = action.payload;
      newState.volume[category][planName] = volume;
      return newState;
    }
    case 'SET_CONTACTS': {
      const { planName, contacts } = action.payload;
      newState.contacts[planName] = contacts;
      return newState;
    }
    case 'SET_STATE': {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}

export default reducer;
